import BaseService from "@/services/BaseService";
import * as URI from "../Accrual/constant";

const action = {
  async getSchemesAction({ commit }, payload) {
    let url = payload.url.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const schemes = await BaseService.getSchemePlanningClient().get(url);
    return schemes.data;
  },
  async getAccrualAction({ commit }, payload) {
    let url = URI.ACCRUAL_LIST_URL.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const accruals = await BaseService.getSchemePlanningClient().get(url);
    commit("setAccrualList", accruals.data.data);
    return accruals.data.data;
  },
  async updateCreateAccrualForm({ commit }, payload) {
    commit("setCreateAccrualForm", payload);
  },
  async saveAccrualFormData({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SAVE_ACCRUAL_FORM_DATA,
      payload
    );
    return response.data;
  },
  async saveAccrualAssociatedPlan({ commit }, payload) {
    let url = URI.SAVE_ASSOCIATED_PLAN_DATA.replace(
      "{division}",
      payload.divisionKey
    ).replace("{accrualNo}", payload.accrualNumber);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.planData
    );
    return response.data;
  },
  async getAccrualAssociatedPlan({ commit }, payload) {
    let url = URI.GET_ACCRUAL_ASSOCIATED_PLAN_FORM_URL.replace(
      "{accrualId}",
      payload.accrualId
    ).replace(
      "{isEdited}",
      payload.isEdited
    ).replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const accrualAssociatedPlan =
      await BaseService.getSchemePlanningClient().get(url);
    return accrualAssociatedPlan.data;
  },
  async getSavedAccrualFormAction({ commit }, payload) {
    let url = URI.GET_SAVED_ACCRUAL_FORM_URL.replace("{accrualId}", payload);
    const savedAccrualFormData =
      await BaseService.getSchemePlanningClient().get(url);
    return savedAccrualFormData.data.data;
  },
  async deleteAccrualModal({ commit }, payload) {
    const url = URI.DELETE_ACCRUAL_URL;
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload,
    });
    return response.data;
  },
  async downloadAccrualExcel({ commit }, payload) {
    let url = URI.DOWNLOAD_ACCRUAL_EXPORT_FILE.replace("{payload}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async uploadAccrualPlanExcel({ commit }, payload) {
    let url = URI.EDITED_LIST_IMPORT_URL.replace(
      "{accrual}",
      payload.accrualNumber
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async deleteAccrualAssociatedPlans({ commit }, payload) {
    const url = URI.DELETE_ACCRUAL_ASSOCIATED_PLANS_URL;
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload,
    });
    return response.data;
  },
  async executePlans({ commit }, payload) {
    const url = URI.EXECUTE_ACCRUAL_PLANS_URL;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async accrualReportExportAction({ commit }, payload) {
    let url = URI.ACCRUAL_REPORT_EXPORT.replace(
      "{buttonId}",
      payload.id
    ).replace("{accrualId}", payload.accrualId);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async downloadAddAccrualExportExcel({ commit }, payload) {
      const url = URI.DOWNLOAD_ADD_ACCRUAL_EXPORT_EXCEL_URL
        .replace("{accrualId}",payload.accrualId)
        .replace("{currentPage}",payload.page.currentPage)
        .replace("{pageSize}", payload.page.pageSize)
        .replace("{value}", payload.sord.value)
        .replace("{sortOrder}", payload.sord.__sortOrder);
      const response = await BaseService.getSchemePlanningClient().get(
        url,
        {
          responseType: "blob",
        }
      );
      return response;
    },
};

export default action;
